export default "__VITE_ASSET__STsx5P2o__"